import { StyledNoMatchingResult } from './Projects.style';

const NoMatchingResult = () => {
  return (
    <StyledNoMatchingResult>
      No matching Projects. Adjust your search and try again.
    </StyledNoMatchingResult>
  );
};

export default NoMatchingResult;
